const CustomerLogsAdapter = data => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'user.name': i.user?.hide_name,
    'user.surname': i.user?.hide_surname,
    'user.sex_short': i.user?.sex_short,
    'user.address': i.user?.address,
    'user.city': i.user?.city,
  });

  if (Array.isArray(data)) {
    data.forEach(i => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default CustomerLogsAdapter;
